import Button from '@base/Button/Button';
import H3 from '@base/H3/H3';
import LottieAnimation from '@base/LottieAnimation/LottieAnimation';
import P1 from '@base/P1/P1';
import Dialog from '@comp/Dialog/Dialog';
import { ADD_TO_PLANNER_TRY_NOW_CLICKED } from '@constants/segment';
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import { getAnimationPath } from '@utils/animationHelpers';
import { FC } from 'react';
import { AnyArgVoidReturnFunction } from 'types/utils';

const StyledDialog = styled(Dialog)`
  &.MuiDialog-root {
    .MuiDialog-container {
      position: relative;
      .MuiPaper-root {
        border-radius: ${Spacings.SPACING_2B};
      }
    }
  }
`;

const Container = styled.div`
  padding: ${Spacings.SPACING_6B};
  align-items: center;
  display: flex;
  position: relative;
  flex-direction: column;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: ${Spacings.SPACING_4B};
    justify-content: space-between;
  }
`;

const DialogHeader = styled(H3)`
  margin-top: ${Spacings.SPACING_8B};
`;

const Message = styled(P1)`
  margin-top: ${Spacings.SPACING_2B};
  color: var(--color-text-secondary);
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_6B};
  justify-content: center;
  margin-top: ${Spacings.SPACING_8B};
  ${mediaQuery.uptoTablet} {
    width: 100%;
    justify-content: space-between;
  }
`;

const LaterButton = styled(Button)<any>`
  ${mediaQuery.uptoTablet} {
    width: 135px;
    margin-right: 0px;
    :last-child {
      margin-left: ${Spacings.SPACING_4B};
    }
  }
`;

const TryNowButton = styled(Button)<any>`
  background-color: var(--color-text-primary);
  color: var(--color-text-tertiary);
  ${mediaQuery.uptoTablet} {
    width: 135px;
    margin-right: 0px;
    :last-child {
      margin-left: ${Spacings.SPACING_4B};
    }
  }
`;

const AnimationContainer = styled(LottieAnimation)`
  width: 556px;
  height: 238px;
  border-radius: ${Spacings.SPACING_2B};
  background: var(--color-i-blue);
`;

interface IAddToPlannerDialogProps {
  show: boolean;
  onLaterClick: AnyArgVoidReturnFunction;
  handleCreateCoursePlan: AnyArgVoidReturnFunction;
}

const AddToPlannerDialog: FC<IAddToPlannerDialogProps> = ({
  show,
  onLaterClick,
  handleCreateCoursePlan
}) => {
  return (
    <StyledDialog onClose={onLaterClick} dialogState={show}>
      <Container>
        <AnimationContainer src={getAnimationPath('addToPlanner.json')} />
        <DialogHeader>Learn every day from planner</DialogHeader>
        <Message>
          Next time, watch these classes right from your planner
        </Message>
        <ButtonWrapper>
          <LaterButton
            variant="hollow"
            color="black"
            label="Later"
            onClick={onLaterClick}
          />
          <TryNowButton
            color="black"
            label="Yes, try now"
            variant="filled"
            onClick={() =>
              handleCreateCoursePlan(ADD_TO_PLANNER_TRY_NOW_CLICKED)
            }
          />
        </ButtonWrapper>
      </Container>
    </StyledDialog>
  );
};

export default AddToPlannerDialog;
